import ImageWithFallback from "@/components/ImageWithFallback";
import { DefaultIcon } from "@/constant/imagePath";
import { TRANSACTION_CATEGORY } from "@/constant/Transactions/category";
import { formatDateTime, truncate } from "@/utils/helper";
import { FaFilePdf } from "react-icons/fa";

export const columns = () => {
  return [
    {
      accessorKey: "code",
      header: "Transaction ID",
    },
    {
      accessorKey: "reference_code",
      cell: ({ row }) => {
        const referenceCode = row.original.reference_code;
        const href =
          row.original.code_prefix === TRANSACTION_CATEGORY.SUPPORT_TICKET
            ? `/communication-management/support-tickets?filter[keyword]=${referenceCode}`
            : `?filter[keyword]=${referenceCode}`;
  
        return referenceCode ? (
          <a href={href} className="underline text-blue-800" target="_blank" rel="noreferrer">
            {referenceCode}
          </a>
        ) : (
          "-"
        );
      },
      header: "Reference ID",
    },
    {
      id: "creation_date",
      accessorKey: "created_at",
      accessorFn: (row) => formatDateTime(row.created_at, true),
      header: "Creation Date",
    },
    {
      id: "creation_time",
      accessorKey: "created_at",
      accessorFn: (row) => formatDateTime(row.created_at, false, true),
      header: "Creation Time",
    },
    {
      accessorKey: "category.name",
      header: "Category",
      enableSorting: false,
    },
    {
      accessorKey: "subcategory.name",
      header: "Subcategory",
    },
    {
      accessorKey: "party_one.username",
      cell: ({ row }) => (
        row.original.party_one?.username ? (<a
          href={`/user-management/web-user-list?filter[username]=${row.original.party_one.username}`}
          className="underline text-blue-800"
          target="_blank"
          rel="noreferrer"
        >
          {row.original.party_one.username}
        </a>)
        : "-"
      ),
      header: "Party 1",
    },
    {
      accessorKey: "party_two.username",
      cell: ({ row }) => (
        row.original.party_two?.username ? (<a
          href={`/user-management/web-user-list?filter[username]=${row.original.party_one.username}`}
          className="underline text-blue-800"
          target="_blank"
          rel="noreferrer"
        >
          {row.original.party_two.username}
        </a>)
        : "-"
      ),
      header: "Party 2 (if applicable)",
    },
    {
      accessorKey: "amount",
      header: "Amount",
    },
    {
      accessorKey: "currency.code",
      header: "Currency",
    },
    {
      accessorKey: "invoice",
      cell: ({ row }) => {
        const item = row.original.invoice;
        return item ? (
          <div className="flex items-center space-x-2">
            <div className="w-5">
              {item.mime === "pdf" ? (
                <FaFilePdf className="text-red-500 text-lg" />
              ) : (
                <ImageWithFallback url={item.url} thumbnailSrc={DefaultIcon} />
              )}
            </div>
            <div className="flex-1">
              <a
                href={item.url}
                className="underline text-blue-800"
                target="_blank"
                rel="noreferrer"
              >
                {truncate(item.file_name)}
              </a>
            </div>
          </div>
        ) : (
          "-"
        );
      },
      header: "Invoice",
      enableSorting: false,
    },    
    {
      accessorKey: "actor.username",
      header: "Admin User",
    },
    {
      accessorKey: "comment",
      header: "Admin Comment",
    },
    {
      id: "attachments",
      cell: ({ row }) => (
        row.original.attachments.length > 0 ? (
          <div className="flex flex-col space-y-1">
            {row.original.attachments.map((item, index) => (
              <div key={index} className="flex items-center space-x-2">
                <div className="w-5">
                  {item.mime === "pdf" ? (
                    <FaFilePdf className="text-red-500 text-lg" />
                  ) : (
                    <ImageWithFallback
                      url={item.url}
                      thumbnailSrc={DefaultIcon}
                    />
                  )}
                </div>
                <div className="flex-1">
                  <a
                    href={item.url}
                    className="underline text-blue-800"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {truncate(item.file_name)}
                  </a>
                </div>
              </div>
            ))}
          </div>
        )
        : "-"
      ),
      header: "Admin Attachments",
    },
  ];
};
